<script>
import axios from "@/services/mediligo-axios";

export default {
  name: "neoparent-activation-access",
  data() {
    return {
      error: "",
      accessCode: null,
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    async checkCode() {
      this.loading = true;
      this.error = "";
      const res = await axios.post('api/userInviteCheck/redeem', {
        code: this.accessCode
      });
      if (res.data.error) {
        this.error = this.$t(res.data.message);
      } else {
        window.location="/settings/create-profile"
      }
    }
  }
};
</script>

<template>
  <v-container fluid class="d-flex flex-column">
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="field">
      <InputField
        v-model="accessCode"
        :labelTitle="$t('dash.auth.code')"
        placeholder="XXXXX"
        :disabled="loading"
        margin="25px auto"
      ></InputField>
      <LoadingButton v-if="loading"></LoadingButton>
      <Button class="mt-2" @click.native="checkCode()" v-else>{{ $t('dash.auth.confirm') }}</Button>
    </div>
  </v-container>
</template>

<style scoped lang="scss">

</style>
